import { GET_COORDINATOR_EXAM_LEVELS_QUERY_KEY } from '../../constants/queryKeys';
import { useCustomQuery } from '../../hooks/query';
import axiosClient from '../axiosClient';
import { GET_COORDINATOR_EXAM_LEVELS_URL } from '../../constants/apiUrls';
import { DropDownItem } from '../../hooks/dropdown';

export const useGetCoordinatorExamLevels = () => {
  const getCoordinatorExamLevels = async () => {
    const res = await axiosClient.get<DropDownItem[]>(GET_COORDINATOR_EXAM_LEVELS_URL);
    return res.data;
  };

  return useCustomQuery(GET_COORDINATOR_EXAM_LEVELS_QUERY_KEY, getCoordinatorExamLevels);
};
